var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("embroideryCircleService", ["$http", function ($http) {
    return {
        getMembershipPlans: function () {
            return $http.get("storefrontapi/club/membershipplans");
        },
        getMembershipPageContent: function () {
            return $http.get('embroidery-circle/embroiderycirclepagecontent');
        }
    }
}]);
